import { render, staticRenderFns } from "./OurTeam.vue?vue&type=template&id=6bca08fa&scoped=true"
var script = {}
import style0 from "./OurTeam.vue?vue&type=style&index=0&id=6bca08fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bca08fa",
  null
  
)

export default component.exports